/** Recorta no centro em proporção 4:3 e reduz para 800x600. Retorna um JPEG leve. */
export async function portfolioImageBlob(file, width = 800, height = 600) {
  const bitmap = await createImageBitmap(file);
  try {
    const target = width / height;
    let sw = bitmap.width;
    let sh = bitmap.height;
    if (sw / sh > target) sw = sh * target;
    else sh = sw / target;
    const sx = (bitmap.width - sw) / 2;
    const sy = (bitmap.height - sh) / 2;

    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');
    // Fundo branco, para imagens PNG com transparência não ficarem pretas
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, width, height);
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(bitmap, sx, sy, sw, sh, 0, 0, width, height);

    return await new Promise((resolve, reject) =>
      canvas.toBlob(
        (blob) => (blob ? resolve(blob) : reject(new Error('Não foi possível processar a imagem.'))),
        'image/jpeg',
        0.9
      )
    );
  } finally {
    bitmap.close();
  }
}